import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { BasketDiscountResponse } from '@app/api/marketplace/models';

export function basketDiscountsOverlapValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const checked: Array<BasketDiscountResponse> = [];
    let error = false;
    let maximum = 99999999;
    control.value.forEach((item: BasketDiscountResponse) => {
      const itemCopy = { ...item };
      if (!itemCopy.siteMaxOrderValue) {
        itemCopy.siteMaxOrderValue = maximum;
      }
      if (
        !checked.find((checked) => {
          return (
            ((checked.siteMinOrderValue ?? 0) <=
              (itemCopy.siteMinOrderValue ?? 0) &&
              (checked.siteMaxOrderValue ?? 0) >=
                (itemCopy.siteMinOrderValue ?? 0)) ||
            ((checked.siteMinOrderValue ?? 0) <=
              (itemCopy.siteMaxOrderValue ?? 0) &&
              (checked.siteMaxOrderValue ?? 0) >=
                (itemCopy.siteMaxOrderValue ?? 0))
          );
        })
      ) {
        checked.push(itemCopy);
      } else {
        error = true;
      }
    });
    return error ? { invalidBasketDiscountsOverlap: true } : null;
  };
}

export function basketDiscountsGapValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value?.length === 0) {
      return null;
    }
    return control.value?.every((item: BasketDiscountResponse, idx: number) => {
      if (idx === 0) {
        return item.siteMaxOrderValue
          ? item.siteMaxOrderValue > 0
          : item.siteMaxOrderValue !== 0;
      } else if (idx === control.value?.length - 1) {
        return (
          (item.siteMinOrderValue ?? 0) -
            control.value[idx - 1].siteMaxOrderValue <=
          1
        );
      } else {
        return (
          (item.siteMinOrderValue ?? 0) -
            control.value[idx - 1].siteMaxOrderValue <=
            1 &&
          control.value[idx + 1].siteMinOrderValue -
            (item.siteMaxOrderValue ?? 0) <=
            1
        );
      }
    })
      ? null
      : { invalidBasketDiscountsGap: true };
  };
}
